import styled from 'styled-components';

export const Icon = styled.i`
    font-style: normal;
`;